import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg viewBox="0 0 40 40" fill={props.color || "#1b2670"} {...props}>
            <path d="M13.78 24.98l-7.46-7.47-4.98 4.98 12.44 12.44 24.88-24.88-4.97-4.98-19.91 19.91z" />
        </svg>
    ),
    defaultToTrue,
);
